module.exports = __webpack_public_path__ + "static/media/sarajeva.479bc662.jpg";